 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLCH00_FM01_HALF from '@/components/xhtml/ch00_fm01_half'
 import XHTMLCH00_FM02 from '@/components/xhtml/ch00_fm02'
 import XHTMLCH00_FM03_TITLE from '@/components/xhtml/ch00_fm03_title'
 import XHTMLCH00_FM04_COPY from '@/components/xhtml/ch00_fm04_copy'
 import XHTMLCH00_FM05_DED from '@/components/xhtml/ch00_fm05_ded'
 import XHTMLCH00_FM06_TOC from '@/components/xhtml/ch00_fm06_toc'
 import XHTMLCH00_FM07_ACK from '@/components/xhtml/ch00_fm07_ack'
 import XHTMLCH00_FM08_INTRO from '@/components/xhtml/ch00_fm08_intro'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH16_INDEX from '@/components/xhtml/ch16_index'
 import XHTMLCH13_FN01 from '@/components/xhtml/ch13_fn01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/abtnyup_press",
 			"name" : "xhtml/abtnyup_press",
 			"component" : XHTMLABTNYUP_PRESS
 		},
 		{
 			"path" : "/xhtml/ch00_fm01_half",
 			"name" : "xhtml/ch00_fm01_half",
 			"component" : XHTMLCH00_FM01_HALF
 		},
 		{
 			"path" : "/xhtml/ch00_fm02",
 			"name" : "xhtml/ch00_fm02",
 			"component" : XHTMLCH00_FM02
 		},
 		{
 			"path" : "/xhtml/ch00_fm03_title",
 			"name" : "xhtml/ch00_fm03_title",
 			"component" : XHTMLCH00_FM03_TITLE
 		},
 		{
 			"path" : "/xhtml/ch00_fm04_copy",
 			"name" : "xhtml/ch00_fm04_copy",
 			"component" : XHTMLCH00_FM04_COPY
 		},
 		{
 			"path" : "/xhtml/ch00_fm05_ded",
 			"name" : "xhtml/ch00_fm05_ded",
 			"component" : XHTMLCH00_FM05_DED
 		},
 		{
 			"path" : "/xhtml/ch00_fm06_toc",
 			"name" : "xhtml/ch00_fm06_toc",
 			"component" : XHTMLCH00_FM06_TOC
 		},
 		{
 			"path" : "/xhtml/ch00_fm07_ack",
 			"name" : "xhtml/ch00_fm07_ack",
 			"component" : XHTMLCH00_FM07_ACK
 		},
 		{
 			"path" : "/xhtml/ch00_fm08_intro",
 			"name" : "xhtml/ch00_fm08_intro",
 			"component" : XHTMLCH00_FM08_INTRO
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js